"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const updatePipLevels = (levels, pipIds) => {
    Object.entries(levels).forEach(([key, value]) => {
        const pip = document.getElementById(pipIds[key]);
        if (pip) {
            pip.style.height = `${value < 0.05 ? 5 : value * 40}px`;
        }
    });
};
const useAudioLevels = ({ mediaStream, computeLevels = true, elementIds, }) => {
    const animationRef = (0, react_1.useRef)(0);
    (0, react_1.useEffect)(() => {
        const audioTracks = mediaStream === null || mediaStream === void 0 ? void 0 : mediaStream.getAudioTracks();
        if (!mediaStream || !audioTracks || !computeLevels) {
            return () => { };
        }
        const context = new AudioContext();
        const analyser = context.createAnalyser();
        analyser.fftSize = 2048;
        const mediaStreamSource = context.createMediaStreamSource(mediaStream);
        if (audioTracks.length) {
            mediaStreamSource.connect(analyser);
            const bufferLength = analyser.frequencyBinCount;
            const dataArray = new Uint8Array(bufferLength);
            const measure = () => {
                analyser.getByteFrequencyData(dataArray);
                const lowCutoff = 100; // Adjust according to your preference
                const midCutoff = 250; // Adjust according to your preference
                const midHighCutoff = 300; // Adjust according to your preference
                let lowSum = 0.0;
                let midSum = 0.0;
                let midHighSum = 0.0;
                let highSum = 0.0;
                let lowCount = 0;
                let midCount = 0;
                let midHighCount = 0;
                let highCount = 0;
                const iterations = Math.min(100, bufferLength);
                for (let i = 0; i < iterations; i++) {
                    const frequency = i * (context.sampleRate / bufferLength);
                    const amplitude = dataArray[i] / 255; // Normalize amplitude to [0, 1]
                    if (frequency < lowCutoff) {
                        lowSum += amplitude;
                        lowCount++;
                    }
                    else if (frequency < midCutoff) {
                        midSum += amplitude;
                        midCount++;
                    }
                    else if (frequency < midHighCutoff) {
                        midHighSum += amplitude;
                        midHighCount++;
                    }
                    else {
                        highSum += amplitude;
                        highCount++;
                    }
                }
                const lowValue = lowCount ? lowSum / lowCount : 0;
                const midValue = midCount ? midSum / midCount : 0;
                const midHighValue = midHighCount ? midHighSum / midHighCount : 0;
                const highValue = highCount ? highSum / highCount : 0;
                updatePipLevels({ low: lowValue, mid: midValue, midHigh: midHighValue, high: highValue }, elementIds);
                animationRef.current = requestAnimationFrame(measure);
            };
            animationRef.current = requestAnimationFrame(measure);
            return () => {
                mediaStreamSource.disconnect(analyser);
                context.close();
                analyser.disconnect();
                cancelAnimationFrame(animationRef.current);
                updatePipLevels({ low: 0, mid: 0, midHigh: 0, high: 0 }, elementIds);
            };
        }
        return () => { };
    }, [computeLevels, elementIds, mediaStream]);
};
exports.default = useAudioLevels;
//# sourceMappingURL=useAudioLevels.js.map